import { formatDistance } from "date-fns";
import type { Database } from "@frankly/shared-types";

/** The last-run row lead-flow-monitor overwrites after every prod run (#1302). */
export type LeadFlowMonitorRun = Pick<
  Database["public"]["Tables"]["lead_flow_monitor_runs"]["Row"],
  "checked_at" | "status" | "incident_open"
>;

/** A run older than this means the hourly cron has stopped calling the monitor. */
const LEAD_FLOW_STALE_MS = 2 * 60 * 60 * 1000;

export function describeLeadFlowRun(run: LeadFlowMonitorRun | null, nowMs: number): { text: string; warning: boolean } {
  if (!run) return { text: "Lead-flow monitor: no run recorded yet", warning: true };
  // Clamp clock skew so a row a second "ahead" never reads "in less than a minute".
  const checkedMs = Math.min(Date.parse(run.checked_at), nowMs);
  const label = run.incident_open ? "incident open" : run.status.replace(/_/g, " ");
  const stale = nowMs - checkedMs > LEAD_FLOW_STALE_MS;
  return {
    text: `Lead-flow monitor: last checked ${formatDistance(checkedMs, nowMs, { addSuffix: true })} — ${label}`,
    warning: stale || run.incident_open,
  };
}
